import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef } from "react"
import { Row, Col, Card, CardBody, Button, CardTitle, CardSubtitle, Modal, ModalBody } from "reactstrap"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb";
// import Utils from '../Utility';
import Utils from '../Utility';
import Loader from "../../components/Loader";
import DataTable from 'react-data-table-component';
import { get, put } from '../../helpers/api_helper'
import { toast } from 'react-toastify';
// import DeleteModal from './DeleteModal';
import DeleteModal from '../../components/ConfirmModal/DeleteModal';
import moment from 'moment'
import { AvField, AvForm } from 'availity-reactstrap-validation'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';


const Enquiry = props => {
    const { user } = props;
    const [currentData, setCurrentData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [deleteModal, setDeleteModal] = useState(false);
    const [modal, setModal] = useState(false);
    const formRef = useRef();


    useEffect(() => {
        if (user?.token)
            getData();
    }, [user]);

    const getData = (e, v) => {
        if (!loading) {
            setLoading(true);
            get("/contact?str=" + v?.search, { token: user?.token })
                .then(res => {
                    setLoading(false);
                    if (res?.statusCode == 200) {
                        setData(res?.data);
                    } else {
                        toast.error(res?.error);
                    }
                })
                .catch(err => {
                    setLoading(false);
                    console.log('error while getting enquiries', err);
                    toast.error('Something Went Wrong!');
                })
        }
    }

    useEffect(() => {
        setColumns([
            {
                name: 'S.N',
                cell: (row, index) => <>
                    <span>{index + 1}</span>
                </>,
                maxWidth: '50px'
            },
            {
                name: 'Name',
                selector: row => row?.name,
                cell: (row) => <div>
                    <span style={{ textTransform: 'capitalize', marginLeft: 5 }}>{row?.name}</span>
                </div>,
                sortable: true,
                maxWidth: '150px'
            },
            {
                name: 'Email',
                selector: row => row?.email,
                sortable: true,
                // maxWidth: '210px',
            },
            {
                name: 'Mobile',
                selector: row => row?.mobile,
                sortable: true,
                maxWidth: '110px'
            },
            {
                name: 'Service',
                selector: row => row?.service?.map(item => item + ", "),
                cell: row => <span>{row?.service?.map(item => item + ", ")}</span>,
                sortable: true,
                maxWidth: '120px'
            },
            {
                name: 'Budget',
                selector: row => row?.budget,
                sortable: true,
                maxWidth: '120px'
            },
            {
                name: 'Created At',
                selector: row => row?.createdAt,
                cell: row => <span>{moment(row?.createdAt).format("DD MMM, YYYY hh:mm a")}</span>,
                sortable: true,
                maxWidth: '170px'
            },
            {
                cell: (row) => <>
                    {/* <Button onClick={() => handleUpdateProj(row)}
                        title={"Reply"}
                        style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}><span className="mdi mdi-comment" style={{ fontSize: 20 }}></span></Button> */}
                    <Button onClick={() => handleDeleteProj(row)}
                        title={"Delete"}
                        style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
                </>,
                name: 'Action',
                ignoreRowClick: true,
                maxWidth: '80px'
            },
        ]);
    }, [data]);

    const handleUpdateStatus = (row) => {
        setCurrentData({ ...row, actionType: 'Status' });
        setDeleteModal(true);
    }

    const handleDeleteProj = (row) => {
        setCurrentData({ ...row, actionType: "Delete" });
        setDeleteModal(true);
    }

    const handleUpdateProj = (row) => {
        setCurrentData(row);
        setModal(true);
    }

    const onDelete = () => {
        setLoading(true);
        let body = {
            contactId: currentData?._id,
            type: "Contact",
            token: user?.token
        }
        if (currentData?.actionType == 'Status')
            body = { ...body, isActive: !currentData?.isActive }
        else
            body = { ...body, isDeleted: true }
        put("/contact", body)
            .then(res => {
                setLoading(false);
                if (res?.statusCode == 200) {
                    getData();
                    setDeleteModal(false);
                    setCurrentData(null);
                } else {
                    toast.error(res?.error);
                }
            })
            .catch(err => {
                setLoading(false);
                console.log('error while getting enquiries', err);
                toast.error('Something Went Wrong!');
            })
    }

    const handleValidSubmit = (e, v) => {
        let body = {
            contactId: currentData?._id,
            reply: v?.reply,
            isActive: false,
            token: user?.token
        }
        put("/contact/", body)
            .then(res => {
                setLoading(false);
                if (res?.statusCode == 200) {
                    getData();
                    setModal(false);
                    setCurrentData(null);
                } else {
                    toast.error(res?.error);
                }
            })
            .catch(err => {
                setLoading(false);
                console.log('error while getting enquiries', err);
                toast.error('Something Went Wrong!');
            })
    }

    const ExpandedComponent = ({ data }) =>
        <div className='expending_box'>
            <Row>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <h5><b>Email : </b></h5>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <p>{data?.email}</p>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <h5><b>Mobile : </b></h5>
                    </div>
                </Col>
                <Col lg={6}>
                    <div className='expend_detail'>
                        <p>{data?.mobile}</p>
                    </div>
                </Col>
                <Col lg={1}>
                    <div className='expend_detail'>
                        <h5><b>Message : </b></h5>
                    </div>
                </Col>
                <Col lg={11}>
                    <div className='expend_detail'>
                        <p>{data?.message}</p>
                    </div>
                </Col>
            </Row>
        </div>


    return (
        <React.Fragment>
            <div className="page-content">
                <Loader visible={loading} />
                <Breadcrumb title={Utils.projectName} breadcrumbItem="Contact Us" />
                <DeleteModal
                    show={deleteModal}
                    onDeleteClick={() => onDelete()}
                    onCloseClick={() => setDeleteModal(false)}
                    data={currentData}
                />
                <Card>
                    <CardBody>
                        <Row>
                            <Col md={12}>
                                <CardTitle className="h4">Contact Us</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Inquiries those who filled the contact us form, All the <code>Users will not be able </code> to fill that form again until you don't <code>Completed</code> that <code>Iquiry.</code>
                                </CardSubtitle> */}
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <div className='mb-4 px-3'>
                                    <AvForm onValidSubmit={getData} ref={formRef}>
                                        <Row className='mt-2'>
                                            <Col md={9}>
                                                <AvField
                                                    name="search"
                                                    placeholder="Search contact by name, email, mobile no."
                                                />
                                            </Col>
                                            <Col md={1}>
                                                <button type="submit" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor, float: 'right' }} className="btn btn-sign">{currentData?._id ? 'Search' : 'Search'}</button>
                                            </Col>
                                            <Col md={2}>
                                                <button type="reset" style={{ border: 'none', backgroundColor: Utils.themeColor, color: Utils.textColor }}
                                                    onClick={() => { formRef?.current?.reset(); getData(); }}
                                                    className="btn btn-sign" >Clear Filter</button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </div>
                            </Col>
                        </Row>
                        <DataTable
                            columns={columns}
                            data={data}
                            pagination
                            expandableRows={true}
                            expandableRowsComponent={ExpandedComponent}
                            expandableRowsComponentProps={row => row.Action}
                            customStyles={{
                                headCells: {
                                    style: {
                                        color: 'black',
                                        fontWeight: 'bold',
                                        fontSize: 15,
                                    },
                                },
                            }}
                        />

                    </CardBody>
                </Card>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = state => {
    const { user } = state.Profile;
    return { user }
}

export default withRouter(
    connect(mapStatetoProps, {})(Enquiry)
)
